import { render, staticRenderFns } from "./DeliveryPointOpeningHoursCard.vue?vue&type=template&id=3742509d"
import script from "./DeliveryPointOpeningHoursCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointOpeningHoursCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports